<template>
    <div class="grid fixed fixed-max-sm grid-sm-fix corner gap-0 bg-default">
        <div>
            <img class="panel-img corner lazyload img-load-success" loading="lazy" :src="glb.cdnUrl+'vimages/photocustomer.webp'" alt="Home valuation"/>
        </div>
        <div class="inline large corner bg-transparent">
            <mvtHotleadForm :options="hotleadOpt"></mvtHotleadForm>
        </div>
    </div>
</template>

<script src="./valuation-hotlead.js"></script>


